import React from 'react';

const ProductTable = ({ products, onEdit, onToggleDelete, canModify }) => {
  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(value);
  };

  return (
    <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '20px' }}>
      <thead>
        <tr style={{ backgroundColor: '#f5f5f5', borderBottom: '2px solid #ddd' }}>
          <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>Name</th>
          <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>Brand</th>
          <th style={{ padding: '12px', textAlign: 'center', fontWeight: 'bold' }}>Measure</th>
          <th style={{ padding: '12px', textAlign: 'right', fontWeight: 'bold' }}>Cost</th>
          <th style={{ padding: '12px', textAlign: 'right', fontWeight: 'bold' }}>Price</th>
          <th style={{ padding: '12px', textAlign: 'center', fontWeight: 'bold' }}>Status</th>
          {canModify && <th style={{ padding: '12px', textAlign: 'center', fontWeight: 'bold' }}>Actions</th>}
        </tr>
      </thead>
      <tbody>
        {products.map((product) => (
          <tr
            key={product.id}
            style={{
              backgroundColor: product.deleted ? '#f0f0f0' : 'white',
              borderBottom: '1px solid #eee',
              textDecoration: product.deleted ? 'line-through' : 'none',
              opacity: product.deleted ? 0.6 : 1
            }}
            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = product.deleted ? '#e8e8e8' : '#f9f9f9')}
            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = product.deleted ? '#f0f0f0' : 'white')}
          >
            <td style={{ padding: '12px' }}>{product.name}</td>
            <td style={{ padding: '12px' }}>{product.brand}</td>
            <td style={{ padding: '12px', textAlign: 'center' }}>{product.measure.abbreviation}</td>
            <td style={{ padding: '12px', textAlign: 'right' }}>{formatCurrency(product.cost)}</td>
            <td style={{ padding: '12px', textAlign: 'right' }}>{formatCurrency(product.price)}</td>
            <td style={{ padding: '12px', textAlign: 'center' }}>
              <span style={{
                padding: '4px 8px',
                borderRadius: '4px',
                backgroundColor: product.deleted ? '#F22B55' : '#A0BD46',
                color: 'white',
                fontSize: '12px',
                fontWeight: 'bold'
              }}>
                {product.deleted ? 'Deleted' : 'Active'}
              </span>
            </td>
            {canModify && (
              <td style={{ padding: '12px', textAlign: 'center' }}>
                <button
                  onClick={() => onEdit(product.id)}
                  style={{
                    padding: '6px 12px',
                    marginRight: '8px',
                    backgroundColor: '#20BDE2',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '12px'
                  }}
                >
                  Edit
                </button>
                <button
                  onClick={() => onToggleDelete(product.id)}
                  style={{
                    padding: '6px 12px',
                    backgroundColor: product.deleted ? '#A0BD46' : '#F22B55',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '12px'
                  }}
                >
                  {product.deleted ? 'Restore' : 'Delete'}
                </button>
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ProductTable;
